import { requireUser, supabase } from './supabase'
import { createFragranceShareCardClient } from './fragranceSharePayload.mjs'

const fragranceShareCards = createFragranceShareCardClient(supabase)

export async function prepareFragranceShareCard(fragranceId) {
  if (!fragranceId) throw new Error('A fragrance is required to build a share card.')
  await requireUser()
  return fragranceShareCards.prepare(fragranceId)
}

export const resolveFragranceShareCard = token => fragranceShareCards.resolve(token)
export const acceptFragranceShareCard = token => fragranceShareCards.accept(token)
